import styled from "styled-components";

export const MenteeInfoContainer = styled.div`
    display: flex;
    gap: 10px;
`;
export const MenteeImage = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 50%;
`;
export const Image = styled.img`
    width: 100%;
    height: 100%;
    border-radius: 50%
`;
export const MenteeInfo = styled.div`
`;

export const MenteeName = styled.h3`
    color: #302F2F;
    font-family: "Nunito Sans";
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin: 0;
`;

export const MenteeRole = styled.p`
    color: #A6A6A6;
    font-family: "Nunito Sans";
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    margin: 0;
`;


export const Suggestions = styled.div`
    margin-top: 16px;
    text-align: center;
`;

export const HeadText = styled.p`
    color: #302F2F;
    font-family: "Nunito Sans";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin: 0;
`;

export const MatchMakingSliderOuter = styled.div`
  box-sizing: border-box;
  max-width: 100%;
  min-height: 140px;
  width: 100%;
  border-radius: 10px;
  background: #f8f7f9;
  padding: 13px 35px;
  margin-top: 12px;
  display: ${(props) => props.isCenter && "flex"};
  justify-content: ${(props) => props.isCenter && "center"};
  align-items: ${(props) => props.isCenter && "center"};
`;


export const NoMatchedText = styled.p`
    color: #302F2F;
    font-family: "Nunito Sans";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin: 0;
`;


export const NoMatchContainer = styled.div`
    height: 100%;
`;


export const IgnoreSuggestion = styled.div`
    display: flex;
    align-item: flex-end;
    justify-content: flex-end;
    margin-top: 8px;
    gap: 4px;
    cursor: pointer;
`;

export const IgnoreText = styled.p`
    color: #302F2F;
    font-family: "Nunito Sans";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin: 0;
`;

export const SuggestedContainer = styled.div`
`;
export const SuggestedContainerInner = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 4px;
`;
export const Percentage = styled.span`
    display: flex;
    width: 30px;
    height: 30px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 20px;
    background: #FFF;
    position: absolute;
    right: -15px;
    top: 0;
    color: #44449B;
    font-family: "Nunito Sans";
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
`;
export const ProfileImage = styled.div`
    width: 70px;
    height: 70px;
    border-radius: 50%;
    position: relative;
    img{
        width: 100%;
        height: 100%;
        border-radius: 50%;
    }
`;

export const ProfileName = styled.h3`
    color: #302F2F;
    font-family: "Nunito Sans";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin: 0;
`;
export const AssignButton = styled.button`
    width: 75px;
    height: 32px;
    padding: 5px 8px;
    border: none;
    border-radius: 3px;
    background: rgba(79, 68, 155, 0.10);
    color: #44449B;
    font-family: "Nunito Sans";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    cursor: pointer;
    margin-top: 6px;
`;

export const SuggestedContainerOuter = styled.div`
    display: flex;
    justify-content: center;
    gap: 80px;
`;


